import { render } from "./SettingsNotifications.vue?vue&type=template&id=5fb16459"
import script from "./SettingsNotifications.vue?vue&type=script&lang=js"
export * from "./SettingsNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__